"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var classes = {
  container: 'accordion-container',
  headerWithUnderline: 'header-with-underline',
  headerWithoutUnderline: 'header-without-underline',
  content: 'content',
  contentExpanded: 'content-expanded',
  contentExpandedWithPadding: 'content-expanded-with-padding',
  contentClosed: 'content-closed',
  marginTop32: 'margin-top-32',
  marginTop8: 'margin-top-8'
};
exports.classes = classes;